// extracted by mini-css-extract-plugin
module.exports = {"mobile":"ContactForm_mobile__m_1Ss"};